export enum RecurringTypes {
    DEFAULT = 'DEFAULT',
    MONTHLY = 'MONTHLY',
    ANNUAL = 'ANNUAL',
    ONE_OFF = 'ONE_OFF'
}